
class AppointmentPage {

    constructor(selector = '[data-appointment-page]') {

        this.$page = $(selector);

        if (!this.$page.length) {
            return;
        }

        this.$loading = this.$page.find(
            '[data-appointment-page-loading]'
        );

        this.$error = this.$page.find(
            '[data-appointment-page-error]'
        );

        this.$errorMessage = this.$page.find(
            '[data-appointment-page-error-message]'
        );

        this.$component = this.$page.find(
            '[data-appointment-page-component]'
        );

        this.language =
            document.documentElement.lang
                ?.toLowerCase()
                .startsWith('fr')
                ? 'fr'
                : 'en';

        this.init();
    }


    /* =========================================================
       Init
    ========================================================= */

    async init() {

        const bookingSite = this.getBookingSite();

        if (!bookingSite) {
            this.showError(
                this.language === 'fr'
                    ? 'Le magasin n’a pas été spécifié.'
                    : 'No store was specified.'
            );
            return;
        }

        if (!this.isValidBookingSite(bookingSite)) {
            this.showError(
                this.language === 'fr'
                    ? 'Le magasin spécifié est invalide.'
                    : 'The specified store is invalid.'
            );
            return;
        }

        await this.loadStore(bookingSite);
    }


    /* =========================================================
       URL
    ========================================================= */

    getBookingSite() {

        const params = new URLSearchParams(
            window.location.search
        );

        const store = params.get('store');

        if (!store) {
            return null;
        }

        return store.trim().toLowerCase();
    }


    /* =========================================================
       Validation
    ========================================================= */

    isValidBookingSite(bookingSite) {

        return /^[a-z0-9]+$/i.test(bookingSite);
    }


    /* =========================================================
       Load Store Information
    ========================================================= */

    async loadStore(bookingSite) {

        try {

            const response = await fetch(
                `/apps/waitwell/locations/${encodeURIComponent(bookingSite)}`,
                {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json'
                    }
                }
            );

            if (!response.ok) {
                throw new Error(
                    `Store lookup failed: ${response.status}`
                );
            }

            const store = await response.json();

            if (!store || !store.name) {
                throw new Error('Invalid store response');
            }

            const fullAddress = [
                store.address,
                store.city,
                store.province
            ]
                .filter(Boolean)
                .join(', ');

            this.startAppointment({
                bookingSite,
                bookingUrl: '',
                locationId: null,
                name: store.name.replace(/^WW\s/i, '').replace(/\s+\d+\s+\d+$/, '').trim(),
                address: fullAddress,
                phone: store.phone || ''
            });

        } catch (error) {

            console.error(
                'Appointment store lookup error:',
                error
            );

            this.showError(
                this.language === 'fr'
                    ? 'Nous n’avons pas pu charger les informations de ce magasin.'
                    : 'We couldn’t load the information for this store.'
            );
        }
    }


    /* =========================================================
       Start Appointment
    ========================================================= */

    startAppointment(store) {

        if (!window.appointmentModal) {

            this.showError(
                this.language === 'fr'
                    ? 'Le module de rendez-vous n’est pas disponible.'
                    : 'The appointment module is not available.'
            );

            return;
        }

        // Hide loading and error states
        this.$loading.attr('hidden', true);
        this.$error.attr('hidden', true);

        // Show appointment component
        this.$component.removeAttr('hidden');

        /*
         * Reuse existing appointment modal.
         * Store information is now populated from the API.
         */
        window.appointmentModal.open(store);

        // Restore normal page scrolling
        $('body').css('overflow', '');

        // Embedded page accessibility
        this.$component
            .find('.appointment-modal__dialog')
            .removeAttr('aria-modal')
            .attr('role', 'region');

        this.$component
            .find('.appointment-modal')
            .attr('aria-hidden', 'false');

        /*
         * Keep the confirmation visible after booking.
         */
        window.appointmentModal.close = () => {};
    }


    /* =========================================================
       Error
    ========================================================= */

    showError(message) {

        this.$loading.attr('hidden', true);

        this.$component.attr('hidden', true);

        this.$errorMessage.text(message);

        this.$error.removeAttr('hidden');
    }

}


/* =============================================================
   Initialize
============================================================= */

$(function () {
    window.appointmentPage = new AppointmentPage();
});
